window.relatedProjectsSliderHandler = () => {
  document.addEventListener('DOMContentLoaded', () => {
    sliderEvents();
    carouselEvents();
    sliderImagesProportions();
    sliderArrows();
    stopVideosEvents();
  });

  window.addEventListener('resize', () => {
    sliderImagesProportions();
    sliderArrows();
  });

  const sliderEvents = () => {
    const sliderWrapper = document.querySelector('.jsRelatedProjectsSliderWrapper');

    $(sliderWrapper).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      useTransform: true,
      nextArrow: $('.jsRelatedProjectsSliderNext'),
      prevArrow: $('.jsRelatedProjectsSliderPrev'),
    });
  };

  const carouselEvents = () => {
    const carousel = document.querySelector('.jsRelatedProjectsCarouselWrapper');
    const slider = document.querySelector('.jsRelatedProjectsMainSliderWrapper');

    $(slider).slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: true,
      fade: true,
      asNavFor: '.jsRelatedProjectsCarouselWrapper',
      nextArrow: $('.jsRelatedProjectsSliderNext'),
      prevArrow: $('.jsRelatedProjectsSliderPrev'),
    });

    $(carousel).slick({
      arrows: true,
      asNavFor: '.jsRelatedProjectsMainSliderWrapper',
      nextArrow: $('.jsRelatedProjectsCarouselSliderNext'),
      prevArrow: $('.jsRelatedProjectsCarouselSliderPrev'),
      centerMode: false,
      dots: false,
      focusOnSelect: true,
      swipeToSlide: true,
      slidesToShow: 5,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            centerMode: false,
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.75,
          }
        },
      ],
    });
  };

  const sliderImagesProportions = () => {
    Promise.all(Array.from(document.images)
      .filter(img => !img.complete)
      .map(img =>
        new Promise(resolve => {
          img.onload = img.onerror = resolve;
        })))
      .then(() => {
        const images = document.querySelectorAll('.jsImage4x3');

        images.forEach(image => {
          setImageProportions(image, 4, 3, 'y-position')
        });
      });
  };

  const sliderArrows = () => {
    const next = document.querySelector('.jsRelatedProjectsSliderNext');
    const prev = document.querySelector('.jsRelatedProjectsSliderPrev');
    const width = window.innerWidth;
    const sliderWidth = document.querySelector('.jsRelatedProjectsWrapper').offsetWidth;
    const margin = (width - sliderWidth) / 2;

    if (window.innerWidth > window.gridBreakpoints.sm) {
      prev.style.left = `-${margin / 2 - (next.offsetWidth / 2)}px`;
      next.style.right = `-${margin / 2 - (next.offsetWidth / 2)}px`;
    } else {
      prev.style.left = "15px";
      next.style.right = "15px";
    }
  }

  const stopVideosEvents = () => {
    window.addEventListener('click', e => {
      const isArrow = e.target.closest('.jsRelatedProjectsSliderArrow');

      if (isArrow) {
        const section = isArrow.closest('.jsRelatedProjectsSlider');
        const sliderWrapper = section.querySelector('.jsRelatedProjectsWrapper');
        const videos = sliderWrapper.querySelectorAll('.jsCustVid');

        videos.forEach(video => {
          const playBtn = section.querySelector('.jsVidPlay');
          const isPlaying = playBtn.getAttribute('data-play');

          if (isPlaying === 'true') {
            playBtn.setAttribute('data-play', 'false');
            video.pause();
          }
        });
      }
    });
  };
};
